/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import React from 'react';
import { Typography, IconButton } from '@mui/material';
import { BsArrowLeftShort } from "react-icons/bs";
import { useNavigate } from 'react-router-dom';
const BackButton = ({ pageTitle }) => {
  const navigate = useNavigate();
  return (
    <>
         <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
      {/* Arrow button on the left */}
      <IconButton color="primary" onClick={() => { navigate(-1) }} style={{ marginRight: '10px' }}>
        <BsArrowLeftShort size={30} />
      </IconButton>

      {/* Centered title */}
      <Typography color="primary" variant="h4" style={{ fontWeight: '700', textAlign: 'center', flexGrow: 1 }}>
        {pageTitle}
      </Typography>
    </div>
     </>
  )

}
export default BackButton;